import cargoArrivedConfirm from './cargoArrivedConfirm'
import createOrder from './createOrder'
import home from './home'
import shotDistance from './shotDistance'
import fdpz from './fdpz'
import shortLighter from './shortLighter'
import delivery from './delivery'
import quickFindResult from './quickFindResult'
import problemAddOrModify from './problemAddOrModify'
import webOrder from './webOrder'
import transfer from './transfer'
import deliveryReceiptRegistration from './deliveryReceiptRegistration' // 签收登记
import homeDeliveryService from './homeDeliveryService' // 送货上门
import freightTrack from './freightTrack' // 货物跟踪
import backOrder from './backOrder' // 回单相关
import printbq from './printbq' // 打印标签
import orderRecord from './orderRecord' // 开单记录



// 定制逻辑处理
export default {
  ...cargoArrivedConfirm,
  ...createOrder,
  ...home,
  ...shotDistance,
  ...fdpz,
  ...shortLighter,
  ...delivery,
  ...quickFindResult,
  ...problemAddOrModify,
  ...webOrder,
  ...transfer,
  ...deliveryReceiptRegistration,
  ...homeDeliveryService,
  ...freightTrack,
  ...backOrder,
  ...printbq,
  ...orderRecord
}
